import { useTheme } from '@shopify/polaris-viz-core';
import { ANNOTATION_Y_AXIS_LABEL_HEIGHT } from '../../constants.js';
import { useEstimateStringWidth } from '../../../../hooks/useEstimateStringWidth.js';
import { jsx } from 'react/jsx-runtime';

const FONT_SIZE = 10;
function AnnotationYAxisLabel({
  axis,
  label,
  x,
  y
}) {
  const selectedTheme = useTheme();
  const width = useEstimateStringWidth(`${label}`, FONT_SIZE);
  const xOffset = axis === 'y2' ? 0 : width;
  return /*#__PURE__*/jsx("text", {
    width: width,
    height: ANNOTATION_Y_AXIS_LABEL_HEIGHT,
    y: y,
    dominantBaseline: "middle",
    fontSize: FONT_SIZE,
    x: x - xOffset,
    fill: selectedTheme.annotations.axisLabelColor,
    children: label
  });
}

export { AnnotationYAxisLabel };
